/* U7 PLP — client-side category filter (US-017) + per-card flavor animations
   (US-016). Progressive enhancement.
   - Filter: runs on ALL devices. Pills toggle; cards show if their category is
     in the selected set (OR). No selection = show everything.
   - Animations: bubble plays when a card is in view, pour on hover. Gated to
     hover-capable, motion-OK devices (mobile/touch keep the static image). */
(function () {
  if (window.__u7PlpInit) return;
  window.__u7PlpInit = true;

  // ---- US-017: multi-select category filter (OR, client-side) --------------
  function initFilter() {
    var root = document.querySelector('.u7-shop');
    if (!root) return;
    var pills = Array.prototype.slice.call(root.querySelectorAll('.u7-shop__filters [data-u7-cat]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.u7-shop__grid > li'));
    if (!pills.length || !cards.length) return;

    function apply() {
      var selected = pills
        .filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })
        .map(function (p) { return p.getAttribute('data-u7-cat'); });
      cards.forEach(function (li) {
        var cat = li.getAttribute('data-u7-cat') || '';
        // hide only when a selection exists and this card isn't in it
        li.hidden = selected.length > 0 && selected.indexOf(cat) === -1;
      });
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        apply();
      });
    });
  }

  // ---- US-016 (deploy call 07-08): cards stay static; pour render on hover ---
  function initFx() {
    var mm = window.matchMedia;
    if (!mm) return;
    if (mm('(prefers-reduced-motion: reduce)').matches) return;
    if (!mm('(hover: hover) and (pointer: fine)').matches) return; // touch/mobile -> static

    var medias = Array.prototype.slice
      .call(document.querySelectorAll('.u7-card-product__media'))
      .filter(function (m) { return m.querySelector('[data-u7-card-fx]'); });
    if (!medias.length) return;

    function vid(m, kind) { return m.querySelector('[data-u7-card-fx="' + kind + '"]'); }
    function play(v) { if (v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } }
    function reset(v) { if (v) { v.pause(); try { v.currentTime = 0; } catch (e) {} } }

    /* Warm the pour video once the card nears the viewport so the first hover
       starts instantly (markup ships preload="none"). */
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = vid(e.target, 'pour'); if (p) { p.preload = 'auto'; }
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '150px 0px' }) : null;

    medias.forEach(function (m) {
      if (io) { io.observe(m); }
      m.addEventListener('mouseenter', function () {
        m.classList.add('is-fx-hover');
        play(vid(m, 'pour'));
      });
      m.addEventListener('mouseleave', function () {
        m.classList.remove('is-fx-hover');
        reset(vid(m, 'pour'));
      });
    });
  }

  function init() { initFilter(); initFx(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
